import React from "react";
import { extractErrorMessage } from "../../../util/api";
import { useTableContext } from "../../components/AdministrateTable";
import { EditXifinAuthConfigModal } from "../../labs/components/EditXifinAuthConfigModal";
import { AdministrateResourceDeleteButton } from "../../components/AdministrateResourceDeleteButton";
import { useDestroyPermission, useUpdatePermission } from "../../utils";

export const XifinAuthConfigActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const xifinOverrideId = row.original.id;
  const [canUpdate] = useUpdatePermission("XifinAuthNumberOverride", xifinOverrideId);
  const [canDestroy] = useDestroyPermission("XifinAuthNumberOverride", xifinOverrideId);

  const handleChange = () => {
    setMessage(`Updated Xifin Auth Override Config ${row.original.id}`);
    refresh();
  };

  return (
    <>
      {canUpdate && <EditXifinAuthConfigModal color="link" xifinConfig={row.original} onUpdate={handleChange} />}

      {canDestroy && (
        <AdministrateResourceDeleteButton
          label="Delete"
          deleteUrl={`/admin/xifin_auth_number_overrides/${xifinOverrideId}`}
          onError={(err) => setError(extractErrorMessage(err))}
          onSuccess={() => {
            setMessage("Successfully removed Xifin Auth Number Override");
            refresh();
          }}
        />
      )}
    </>
  );
};
